import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from '../../services/baseurl.service';
import {
  GitLabCommitOverviewDto,
  GitlabMergeRequestIgnoreSettingDto, GitlabOpenMergeRequests,
  GitLabProjectOverviewDto,
  AiAction, GitlabMrAiActionsEntity, AiActionSearch, MergeMrsResultDto
} from './code-review-models';
import { QwenCommandDto } from '../qwen/qwen.service';
import { AiCommandDto } from '../ai/ai.service';

@Injectable({
  providedIn: 'root'
})
export class CodeReviewService {

  constructor(
    private http: HttpClient,
    private baseUrl: BaseurlService,
  ) { }

  getGitlabReviewProjectsOverview(displayOnlyNonAccepted: boolean): Observable<GitLabProjectOverviewDto[]> {
    return this.http.get<GitLabProjectOverviewDto[]>(`${this.baseUrl.getBaseUrl()}/gitlabReview/overview?onlyNonAccepted=${displayOnlyNonAccepted}`);
  }

  getCommitsPerProject(projectId: number, displayOnlyNonAccepted: boolean): Observable<GitLabCommitOverviewDto[]> {
    return this.http.get<GitLabCommitOverviewDto[]>(`${this.baseUrl.getBaseUrl()}/gitlabReview/project/${projectId}?onlyNonAccepted=${displayOnlyNonAccepted}`);
  }

  setManuallyAccepted(projectIds: number[]): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/gitlabReview/commits/acceptance/MANUALLY_ACCEPTED`, projectIds);
  }

  setMrIgnore(mr: { web_url: string }, b: boolean, reasonId: number): Observable<void> {
    const body: GitlabMergeRequestIgnoreSettingDto = {ignore: b, mrUrl: mr.web_url, reasonId};
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/ignores`, body);
  }


  getMergeRequestsAdvanced(): Observable<GitlabOpenMergeRequests> {
    return this.http.get<GitlabOpenMergeRequests>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/advanced`);
  }

  triggerRefresh(): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/refresh`, {});
  }

  mergeMrs(mrUrls: string[]): Observable<MergeMrsResultDto> {
    return this.http.post<MergeMrsResultDto>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/merge`, {mrUrls});
  }

  setProjectNotMine(settings: GitlabMergeRequestIgnoreSettingDto): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/projectIsMine`, settings);
  }

  deleteProjectNotMine(ignoreId: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl.getBaseUrl()}/gitlab-mr/projectIsMine/${ignoreId}`);
  }

  triggerAiMrAction(action: AiAction): Observable<void> {
    return this.http.post<void>(`${this.baseUrl.getBaseUrl()}/gitlab/aiactions/trigger/mr`, action);
  }

  findAiActionsForMr(mrWebUrl: string): Observable<GitlabMrAiActionsEntity[]> {
    const search: AiActionSearch = { mrWebUrl };
    return this.http.post<GitlabMrAiActionsEntity[]>(`${this.baseUrl.getBaseUrl()}/gitlab/aiactions/find/mr`, search);
  }

  getQwenCommandsForStracliCmdUids(stracliCmdUids: string[]): Observable<QwenCommandDto[]> {
    return this.http.post<QwenCommandDto[]>(`${this.baseUrl.getBaseUrl()}/stracliCommands/qwen/byStracliCmdUids`, stracliCmdUids);
  }

  getAiCommandsForStracliCmdUids(stracliCmdUids: string[]): Observable<AiCommandDto[]> {
    return this.http.post<AiCommandDto[]>(`${this.baseUrl.getBaseUrl()}/stracliCommands/ai/byStracliCmdUids`, stracliCmdUids);
  }
}
